import { useEffect, useState } from "react";

const useBodyScrollLock: () => {
  lock: () => void;
  unlock: () => void;
} = () => {
  const body = document.body;
  const bodyStyle: CSSStyleDeclaration = document.body.style;
  const [isLocked, setIsLocked] = useState(bodyStyle.overflowY === "hidden");

  useEffect(() => {
    if (isLocked) {
      body.classList.add("hid");
    } else {
      body.classList.remove("hid");
    }

    // bodyStyle.overflowY = isLocked ? "hidden" : "auto";
    // bodyStyle.marginRight = isLocked ? "6px" : "0";
    return () => {
      // bodyStyle.overflowY = "auto";
      body.classList.remove("hid");
    };
  }, [isLocked, bodyStyle]);

  const lock: () => void = () => setIsLocked(true);
  const unlock: () => void = () => setIsLocked(false);

  return { lock, unlock };
};

export default useBodyScrollLock;
